import { useEffect, useRef } from 'react'
import './LiquidGlassButton.css'

function LiquidGlassButton({ children, onClick, className = '', type = 'button', disabled = false, ...rest }) {
  const glassButtonRef = useRef(null)

  useEffect(() => {
    const element = glassButtonRef.current
    if (!element) return

    const handleMouseMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      
      const specular = e.currentTarget.querySelector('.glass-specular')
      if (specular) {
        specular.style.background = `radial-gradient(
          circle at ${x}px ${y}px,
          rgba(255,255,255,0.15) 0%,
          rgba(255,255,255,0.05) 30%,
          rgba(255,255,255,0) 60%
        )`
      }
    }
    
    const handleMouseLeave = (e) => {
      const specular = e.currentTarget.querySelector('.glass-specular')
      if (specular) {
        specular.style.background = 'none'
      }
    }
    
    element.addEventListener('mousemove', handleMouseMove)
    element.addEventListener('mouseleave', handleMouseLeave)
    
    return () => {
      element.removeEventListener('mousemove', handleMouseMove)
      element.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [])

  return (
    <button
      ref={glassButtonRef}
      className={`glass-button ${className}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...rest}
    >
      <div className="glass-filter"></div>
      <div className="glass-overlay"></div>
      <div className="glass-specular"></div>
      <div className="glass-content">
        {children}
      </div>
    </button>
  )
}

export default LiquidGlassButton




































